/*
 * Validates a tool input against the strict JSON-schema subset used in
 * toolSchemas.js: type, properties, required, additionalProperties:false,
 * items and enum.
 */

function typeOf(value) {
    if (value === null) return "null";
    if (Array.isArray(value)) return "array";
    if (typeof value === "number") return Number.isInteger(value) ? "integer" : "number";
    return typeof value;
}

function matchesType(expected, value) {
    const actual = typeOf(value);
    if (expected === "number") return actual === "number" || actual === "integer";
    return actual === expected;
}

function check(schema, value, path, errors) {
    if (errors.length >= 10) return;
    if (schema.type && !matchesType(schema.type, value)) {
        errors.push(`${path || "input"} must be ${schema.type === "integer" ? "an integer" : `a ${schema.type}`}`);
        return;
    }
    if (typeof value === "number" && !Number.isFinite(value)) {
        errors.push(`${path || "input"} must be a finite number`);
        return;
    }
    if (schema.enum && !schema.enum.includes(value)) {
        errors.push(`${path || "input"} must be one of: ${schema.enum.join(", ")}`);
        return;
    }
    if (schema.type === "object") {
        const properties = schema.properties ?? {};
        for (const key of schema.required ?? []) {
            if (value[key] === undefined) errors.push(`${path ? `${path}.` : ""}${key} is required`);
        }
        for (const [key, item] of Object.entries(value)) {
            const childPath = path ? `${path}.${key}` : key;
            if (!properties[key]) {
                if (schema.additionalProperties === false) errors.push(`${childPath} is not allowed`);
                continue;
            }
            check(properties[key], item, childPath, errors);
        }
    }
    if (schema.type === "array" && schema.items) {
        value.forEach((item, index) => check(schema.items, item, `${path}[${index}]`, errors));
    }
}

/**
 * @param {object} schema
 * @param {unknown} input
 * @returns {string[]} error messages; empty when valid
 */
export function validateInput(schema, input) {
    const errors = [];
    check(schema, input, "", errors);
    return errors;
}
